/* eslint-disable max-len */
import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Col, Row } from '@thd-olt-component-react/grid';
import { Heading } from '@thd-olt-component-react/heading';
import './Bundle.style.scss';
import BundleItem from '../BundleItem/BundleItem';
import { BundledItems } from '../BundledItems/BundledItems';
import Buybox from '../Buybox/Buybox';

const Bundle = ({
  cartOptions,
  cartReqParams,
  itemId,
  itemInCart,
  message,
  onAddToCartClick,
  onAdd,
  onRemove,
  openInNewTab,
  pricing,
  product,
  products,
  channel
}) => {

  const nonPrimary = products && products.slice(1);
  const productCount = products.length;
  const promoMessage = nonPrimary && productCount ? nonPrimary[0].idPromoDetails : '';

  const bundleItems = nonPrimary && (
    products.map((item, index) => {
      return (
        <BundleItem
          anchor={index === 0}
          anchorProduct={product}
          itemInCart={itemInCart}
          onAdd={onAdd}
          onRemove={onRemove}
          checked={item.checked}
          key={`bundle-item-${item.itemId}-${index}`}
          openInNewTab={openInNewTab}
          product={item.product}
        />
      );
    })
  );

  const BuyBoxComponent = () => (
    <Buybox
      cartOptions={cartOptions}
      cartReqParams={cartReqParams}
      finalPriceMessage
      itemId={itemId}
      message={message}
      onAddToCartClick={onAddToCartClick}
      pricing={pricing}
      strikethrough
    />
  );

  const SingleItem = () => (
    <>
      <div className="fbt-bundle__single-item-wrapper">
        {productCount <= 3
        && <div className="fbt-bundle__items-no-carousel">{bundleItems}</div>}
        <Col className="fbt-bundle__single-item-buybox-wrapper">
          {productCount === 1 && channel !== 'mobile'
          && <BuyBoxComponent />}
        </Col>
      </div>
    </>
  );

  const mobileView = (
    <>
      <div className="fbt-bundle-mobile__items-no-carousel">{bundleItems}</div>
      {promoMessage && (
        <div className="fbt-bundle-mobile__promo-message">
          <p>{promoMessage}</p>
        </div>
      )}
      <Col>
        <BuyBoxComponent />
      </Col>
    </>
  );

  const headerCount = productCount >= 3 ? `(${productCount})` : '';
  const buyboxEligible = productCount >= 2;

  return (
    <>
      <Col>
        <Heading title={`Buy Together & Save ${headerCount}`} underline />
      </Col>
      {channel === 'mobile'
      && (
        <Col nopadding className="fbt-bundle-mobile">
          {mobileView}
        </Col>
      )}
      {channel !== 'mobile'
      && (
        <Col className="fbt-bundle">
          <Col nopadding sm="8" className="fbt-bundle__products-container">
            <Col className="fbt-bundle__bundle-items-wrapper" xs="10" sm="8">
              {productCount === 1
                ? (
                  <SingleItem />
                )
                : (
                  <BundledItems
                    bundleItems={bundleItems}
                    productCount={productCount}
                  />
                )}
            </Col>
          </Col>
          <Col nopadding className="fbt-bundle__purchase-wrapper" xs="10" sm="4">
            {promoMessage && (
              <div className="u__bold fbt-bundle__promo-message">
                <p>{promoMessage}</p>
              </div>
            )}
            {buyboxEligible && (
              <BuyBoxComponent />
            )}
          </Col>
        </Col>
      )}
    </>
  );
};

Bundle.propTypes = {
  cartOptions: PropTypes.objectOf(PropTypes.any).isRequired,
  cartReqParams: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.shape({})
  ]).isRequired,
  itemId: PropTypes.string.isRequired,
  itemInCart: PropTypes.bool.isRequired,
  message: PropTypes.objectOf(PropTypes.any).isRequired,
  onAddToCartClick: PropTypes.func.isRequired,
  openInNewTab: PropTypes.bool.isRequired,
  pricing: PropTypes.shape({}).isRequired,
  product: PropTypes.shape({}).isRequired,
  products: PropTypes.arrayOf(PropTypes.shape({
    itemId: PropTypes.string
  })),
  onAdd: PropTypes.func,
  onRemove: PropTypes.func,
  channel: PropTypes.string
};

Bundle.defaultProps = {
  products: [],
  onAdd: null,
  onRemove: null,
  channel: 'desktop'
};

Bundle.displayName = 'FBTBundle';
export default Bundle;
